import React, { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import api from '../services/api';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { useAlert } from '../context/AlertContext';
import { Eye, EyeOff } from 'lucide-react';
import './Login.css';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const { login } = useContext(AuthContext)!;
    const { showAlert } = useAlert();
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const response = await api.post('/token/', { username, password });
            login(response.data.access, response.data.refresh);

            try {
                const statusRes = await api.get('/company/onboarding-status/', {
                    headers: { Authorization: `Bearer ${response.data.access}` }
                });
                if (!statusRes.data.onboarding_complete) {
                    navigate('/onboarding');
                    return;
                }
            } catch (statusErr) {
                console.error("Error checking onboarding status", statusErr);
            }

            navigate('/scheduling');
        } catch (err) {
            showAlert('Credenciais inválidas', { type: 'error', title: 'Erro ao entrar' });
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-image-panel">
                    <img
                        src="/agendainicioGold.png"
                        alt="Y-Agenda — Gestão de agendamentos"
                        className="login-hero-image"
                    />
                </div>

                <div className="login-form-panel">
                    <div className="login-form-wrapper">
                        <div className="login-brand-header">
                            <h1 className="login-brand-title">Y-Agenda</h1>
                            <p className="login-brand-subtitle">Gestão inteligente de agendamentos</p>
                        </div>
                        <div className="login-form-header">
                            <h2>Bem-vindo de volta</h2>
                            <p>Faça login para acessar sua agenda</p>
                        </div>

                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" controlId="formUsername">
                                <Form.Label>Usuário</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Digite seu usuário"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formPassword">
                                <div className="d-flex justify-content-between align-items-center">
                                    <Form.Label>Senha</Form.Label>
                                    <Link to="/forgot-password" className="forgot-password-link">
                                        Esqueceu a senha?
                                    </Link>
                                </div>
                                <InputGroup className="input-group-password">
                                    <Form.Control
                                        type={showPassword ? "text" : "password"}
                                        placeholder="Digite sua senha"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                    <Button
                                        variant="outline-secondary"
                                        onClick={() => setShowPassword(!showPassword)}
                                        tabIndex={-1}
                                        className="btn-toggle-password"
                                    >
                                        {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                    </Button>
                                </InputGroup>
                            </Form.Group>

                            <div className="d-grid">
                                <Button variant="primary" type="submit" size="lg">
                                    Entrar
                                </Button>
                            </div>
                        </Form>

                        <div className="login-footer text-center mt-4">
                            <small className="text-muted">
                                Desenvolvido por Ypecode Tecnologia © {new Date().getFullYear()}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;